import { transformCurrencyAjax } from '../currency/currency.transformers';
import {
  SearchContestResult,
  SearchContestResultAjax,
  SearchFreelancersResult,
  SearchFreelancersResultAjax,
  SearchHistoryResult,
  SearchHistoryResultAjax,
  SearchKeywordProjectsResult,
  SearchKeywordProjectsResultAjax,
  SearchMyContactsResult,
  SearchMyContactsResultAjax,
  SearchMyProjectsResult,
  SearchMyProjectsResultAjax,
} from './search.model';

function handleProfileImageUnknowns(url: string) {
  return url.includes('img/unknown.png') ? undefined : url;
}

function getFlagCodeFromFlagIcon(url: string) {
  return (url.match(/img\/flags\/png\/(\w+)\.png/) || [])[1] || '';
}

export function transformSearchContest(
  item: SearchContestResultAjax,
): SearchContestResult {
  return {
    bidAvgUsd: item.bid_avg_usd,
    bidCount: item.bid_count,
    bidEndDate: item.bid_enddate,
    contestType: item.contest_type,
    country: item.country,
    currency: transformCurrencyAjax(item.currency),
    entryType: item.entry_type,
    extended: item.extended === '1',
    featured: item.featured === '1',
    hideBids: item.hidebids === '1',
    highlight: item.highlight === '1',
    id: item.id,
    language: item.language,
    locked: item.locked === '1',
    maxBudget: item.maxbudget,
    maxBudgetUsd: item.maxbudget_usd,
    minBudget: item.minbudget_usd,
    minBudgetUsd: item.minbudget_usd,
    name: item.name,
    nda: item.NDA === 'Y',
    neglected: item.neglected === '1',
    nonpublic: item.nonpublic === '1',
    prize: item.prize,
    projectDesc: item.project_desc,
    projectId: item.project_id,
    projectName: item.project_name,
    projectType: item.project_type,
    skill: item.skill,
    skills: item.skills,
    state: Number(item.state),
    status: Number(item.status),
    submitDate: item.submitdate,
    usersId: Number(item.users_id),
  };
}

export function transformSearchHistory(
  item: SearchHistoryResultAjax,
): SearchHistoryResult {
  return {
    id: item.timestamp,
    userId: item.user_id,
    keyword: item.keyword,
    timestamp: item.timestamp * 1000, // Turn seconds to ms
  };
}

export function transformSearchKeywordProjects(
  item: SearchKeywordProjectsResultAjax,
): SearchKeywordProjectsResult {
  return {
    id: Number(item.id),
    currency: transformCurrencyAjax(item.currency),
    jobList: item.jobList,
    maxBudget: Number(item.max_budget),
    minBudget: Number(item.min_budget),
    title: item.name,
    type: item.budget_period === 'Hourly:' ? 'hourly' : 'fixed',
  };
}

export function transformSearchMyContacts(
  item: SearchMyContactsResultAjax,
): SearchMyContactsResult {
  return {
    flagIcon: item.flag_icon,
    flagCode: getFlagCodeFromFlagIcon(item.flag_icon),
    flagName: item.flag_name,
    id: Number(item.id),
    jobList: item.jobList,
    logoUrl: handleProfileImageUnknowns(item.logo_url),
    profileLogoUrl: handleProfileImageUnknowns(item.profile_logo_url),
    publicName: item.public_name,
    reputation: item.reputation,
    username: item.username,
    won: Number(item.won),
  };
}

export function transformSearchMyProjects(
  item: SearchMyProjectsResultAjax,
): SearchMyProjectsResult {
  return {
    amountLeft: item.amount_left,
    bidAmount: Number(item.bid_amount),
    bidId: Number(item.bid_id),
    currency: transformCurrencyAjax(item.currency),
    id: Number(item.project.id),
    jobList: item.jobList,
    paidAmount: Number(item.paid_amount),
    title: item.project.name,
    type: item.type,
    user: {
      fullname: item.user.fullname,
      id: Number(item.user.id),
      profileLogoUrl: item.user.profile_logo_url,
      username: item.user.username,
    },
  };
}

export function transformSearchFreelancers(
  item: SearchFreelancersResultAjax,
): SearchFreelancersResult {
  return {
    completion: item.completion,
    flagIcon: item.flag_icon,
    flagCode: getFlagCodeFromFlagIcon(item.flag_icon),
    flagName: item.flag_name,
    id: item.id,
    jobList: item.jobList,
    profileLogoUrl: handleProfileImageUnknowns(item.profile_logo_url),
    publicName: item.public_name,
    reputation: item.reputation,
    reviews: item.reviews,
    source: item.source,
    username: item.username,
  };
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/sq/webapp/src/app/@shared/datastore/search/search.transformers.ts